import {
    API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY,
    API_ADMIN_DELETE_ANSWEROPTIONLIBRARY,
    API_ADMIN_GET_ANSWEROPTIONLIBRARY,
    API_ADMIN_PATCH_ANSWEROPTIONLIBRARY, ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY, ADMIN_RESET_FOCUS_ANSWEROPTIONLIBRARY
} from "../actions/answerOptionLibrary";
import {API_ADMIN_POST_ANSWEROPTIONLIBRARY} from "actions/answerOptionLibrary";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path ? path[path.currentClient] : undefined,
		currentClient: path ? path.currentClient : DEFAULT_CLIENT,
	}
}

const pathMapping = {
	[API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY]: {
		default: "/admin/answerOptionLibrary",
		v2: "/question-answer-option-library/admin",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_GET_ANSWEROPTIONLIBRARY]: {
		default: (answerOptionId) => `/admin/answerOptionLibrary/${answerOptionId}`,
		v2: (answerOptionId) => `/question-answer-option-library/${answerOptionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_POST_ANSWEROPTIONLIBRARY]: {
		default: "/admin/answerOptionLibrary",
		v2: "/question-answer-option-library",
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_PATCH_ANSWEROPTIONLIBRARY]: {
		default: (answerOptionId) => `/admin/answerOptionLibrary/${answerOptionId}`,
		v2: (answerOptionId) => `/question-answer-option-library/${answerOptionId}`,
		currentClient: DEFAULT_CLIENT,
	},
	[API_ADMIN_DELETE_ANSWEROPTIONLIBRARY]: {
		default: (answerOptionId) => `/admin/answerOptionLibrary/${answerOptionId}`,
		v2: (answerOptionId) => `/question-answer-option-library/${answerOptionId}`,
		currentClient: DEFAULT_CLIENT,
	},
};

export function adminGetAnswerOptionLibrary(tubeLibrary) {
    const version = getVersion(API_ADMIN_GET_ANSWEROPTIONLIBRARY);
    const url = typeof version.path === 'function' ? version.path(tubeLibrary.id) : version.path;
    return {
        type: API_ADMIN_GET_ANSWEROPTIONLIBRARY,
        payload: {
            client: version.currentClient,
            request: {
                url,
            }
        }
    };
}

export function adminGetAllAnswerOptionLibrary() {
    const version = getVersion(API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY);
    const url = typeof version.path === 'function' ? version.path() : version.path;
    return {
        type: API_ADMIN_GET_ALL_ANSWEROPTIONLIBRARY,
        payload: {
            client: version.currentClient,
            request: {
                url,
            }
        }
    };
}

export function adminPostAnswerOptionLibrary(tubeLibrary) {
    const version = getVersion(API_ADMIN_POST_ANSWEROPTIONLIBRARY);
    const url = typeof version.path === 'function' ? version.path() : version.path;
    return {
        type: API_ADMIN_POST_ANSWEROPTIONLIBRARY,
        payload: {
            client: version.currentClient,
            request: {
                url,
                method: "POST",
                data: tubeLibrary
            }
        },

    };
}

export function adminPatchAnswerOptionLibrary(tubeLibrary) {
    const version = getVersion(API_ADMIN_PATCH_ANSWEROPTIONLIBRARY);
    const url = typeof version.path === 'function' ? version.path(tubeLibrary.id) : version.path;
    return {
        type: API_ADMIN_PATCH_ANSWEROPTIONLIBRARY,
        payload: {
            client: version.currentClient,
            request: {
                url,
                method: "PATCH",
                data: tubeLibrary
            }
        },

    };
}

export function adminDeleteAnswerOptionLibrary(tubeLibrary) {
    const version = getVersion(API_ADMIN_DELETE_ANSWEROPTIONLIBRARY);
    const url = typeof version.path === 'function' ? version.path(tubeLibrary.id) : version.path;
    return {
        type: API_ADMIN_DELETE_ANSWEROPTIONLIBRARY,
        payload: {
            client: version.currentClient,
            request: {
                url,
                method: "DELETE"
            }
        },

    };
}

export function initNewAnswerOptionLibrary() {
    return {
        type: ADMIN_INIT_NEW_ANSWEROPTIONLIBRARY
    };
}

export function resetFocusAnswerOptionLibrary() {
    return {
        type: ADMIN_RESET_FOCUS_ANSWEROPTIONLIBRARY
    };
}